import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import CoursesLink from 'components/CoursesLink';

function Course({ item, icon, type, source, campaign, medium }) {
  let articleUrl = [item.alternative_url];
  const getCourseName = () => {
    if (type === 'professionals') {
      return item.displayName;
    }
    if (type === 'services') {
      return item.title;
    }
    return item.name;
  };
  if (!item.alternative_url) {
    if (type.indexOf('courses') !== -1) {
      articleUrl = ['courseUrl', item.slug];
    } else if (type.indexOf('services') !== -1) {
      articleUrl = ['serviceUrl', item.slug];
    } else if (type.indexOf('professionals') !== -1) {
      articleUrl = ['servicesUrl', item.username];
    }
  }
  return (
    <article className="content-post videos">
      <div>
        <CoursesLink
          toRoute={articleUrl}
          source={source}
          campaign={campaign}
          medium={medium}
          courseName={getCourseName()}
        >
          <div className="thumb">
            {icon ? (
              <span className="play">
                <i className={icon} />
              </span>
            ) : null}
            <div className="thumb-wrap">
              <Image src={type === 'professionals' ? item.picture : item.image} srcSet={item?.srcSet} alt={item.name} lazy className="thumb-bg" />
            </div>
          </div>
        </CoursesLink>
      </div>
      <div className="caption">
        <span className="title">
          <CoursesLink
            toRoute={articleUrl}
            source={source}
            campaign={campaign}
            medium={medium}
            courseName={getCourseName()}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {type === 'professionals'
              ? item.displayName
              : type === 'services'
                ? item.title
                : item.name}
          </CoursesLink>
        </span>
      </div>
    </article>
  );
}

Course.propTypes = {
  item: PropTypes.object,
  icon: PropTypes.string,
  type: PropTypes.string,
  source: PropTypes.string,
  campaign: PropTypes.any,
  medium: PropTypes.any
};

export default Course;
